import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = { class: "tooltip-body" }
const _hoisted_3 = { class: "tooltip-footer" }

import { ref } from 'vue';
import { FormKit, FormKitMessages } from '@formkit/vue';
import type { VueFormInputProps } from '@/composables/useFormInputData';
import RadioCardListExpandableItem from './RadioCardListExpandableItem.vue';
import ModalDialog from '@/components/ModalDialog/ModalDialog.vue';
import { RichText, Field } from '@sitecore-jss/sitecore-jss-vue';
import { cloneDeep } from 'lodash-es';


export default /*@__PURE__*/_defineComponent({
  __name: 'RadioCardListExpandable',
  props: /*@__PURE__*/_mergeModels({
    bindings: {},
    initialOptionsCountToShow: {},
    modalTitle: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props;

const model = _useModel<string>(__props, "modelValue");
const modalModel = ref<string>();

const inputRef = ref(null);
const showModal = ref(false);
const displayContext = ref(cloneDeep(props.bindings));

if (props.initialOptionsCountToShow) {
  displayContext.value.options = displayContext.value.options.slice(0, props.initialOptionsCountToShow);
}

const onInput = (value?: string) => {
  if (!value) {
    displayContext.value.options = props.bindings.options.slice(0, props.initialOptionsCountToShow);
    return;
  }
  displayContext.value.options = props.bindings.options.filter((option: any) => option.value === value);
  model.value = value;
  showModal.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(FormKit), _mergeProps({
      ref_key: "inputRef",
      ref: inputRef
    }, displayContext.value, {
      modelValue: model.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
      type: "togglebuttons",
      enforced: "true",
      onInput: onInput
    }), {
      label: _withCtx((context) => [
        _createElementVNode("label", {
          for: context.id,
          class: _normalizeClass(["mb-4", context.classes.label])
        }, _toDisplayString(context.label), 11, _hoisted_1),
        _createVNode(_unref(FormKitMessages), {
          node: (inputRef.value as any)?.node
        }, null, 8, ["node"])
      ]),
      default: _withCtx((itemContext) => [
        _createVNode(RadioCardListExpandableItem, _mergeProps(itemContext.option, {
          isSelected: 
            itemContext.option.__original !== undefined
              ? itemContext.option.__original === model.value
              : itemContext.option.value === model.value
          
        }), null, 16, ["isSelected"])
      ]),
      _: 1
    }, 16, ["modelValue"]),
    (!_ctx.bindings.disabled)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "link text-base-bold mt-4",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (showModal.value = true))
        }, _toDisplayString(model.value ? 'Edit selection' : 'Show more'), 1))
      : _createCommentVNode("", true),
    _createVNode(ModalDialog, {
      modelValue: showModal.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showModal).value = $event)),
      closeOnEsc: true,
      showXCloseButton: true,
      size: "md"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(RichText), {
          field: _ctx.modalTitle,
          class: "sticky-modal-header"
        }, null, 8, ["field"]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(FormKit), _mergeProps(_ctx.bindings, {
            id: _ctx.bindings.name + '_modal',
            modelValue: modalModel.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((modalModel).value = $event)),
            type: "togglebuttons",
            enforced: "true",
            label: "",
            validation: ""
          }), {
            default: _withCtx((itemContext) => [
              _createVNode(RadioCardListExpandableItem, _mergeProps(itemContext.option, {
                isSelected: 
                itemContext.option.__original !== undefined
                  ? itemContext.option.__original === modalModel.value
                  : itemContext.option.value === modalModel.value
              
              }), null, 16, ["isSelected"])
            ]),
            _: 1
          }, 16, ["id", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(FormKit), {
            type: "button",
            inputClass: "btn btn-primary btn-md w-full",
            label: "Confirm",
            disabled: !modalModel.value,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (onInput(modalModel.value)))
          }, null, 8, ["disabled"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})